import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ReminderMediaPreviewMC from 'presentation/components/ReminderMediaPreviewMC';

import RightModalLayout from '../layouts/Modal/RightModalLayout';
import getMessageDetail from '../../actions/remindersActions';
import ButtonComponent from '../components/ButtonMC';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';

const ErrorState = ({ t, onRetry }) => (
  <div className="tw-wrapper">
    <RightModalLayout title={t('message_detail.title')}>
      <div className="tw-mt-10 tw-bg-gray-100 tw-rounded-lg tw-flex tw-flex-col tw-items-center">
        <p className="tw-text-red-500 tw-mb-4 tw-ml-2">{t('message_detail.load_error')}</p>
        <ButtonComponent onClick={onRetry} text={t('message_detail.retry')} />
      </div>
    </RightModalLayout>
  </div>
);

const MessageDetailSidebar = ({ messageId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { messageDetail, error } = useSelector(
    (reduxState) => reduxState.messageRemindersReducer
  );

  const onPressSubmit = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  useEffect(() => {
    dispatch(getMessageDetail(messageId));
  }, [dispatch, messageId]);

  if (error) return <ErrorState t={t} onRetry={() => dispatch(getMessageDetail(messageId))} />;

  return (
    <RightModalLayout
      title={t('message_detail.title')}
      className="tw-h-full"
      submitAction={onPressSubmit}
      submitLabel={t('message_detail.understand')}
      submitActionClassName="tw-w-full"
    >
      <div className="tw-bg-gray-200 tw-rounded-lg tw-p-6">
        <div className="tw-font-bold tw-pb-1 tw-text-base">{t('message_detail.message')}</div>
        {messageDetail && (
          <>
            <ReminderMediaPreviewMC
              fileUrl={messageDetail.file_url}
              contentType={messageDetail.content_type}
              templateType={messageDetail.template_type}
              className="tw-mb-3"
            />
            {messageDetail.text ? (
              <div
                className="tw-break-words tw-text-sm tw-mt-2"
                dangerouslySetInnerHTML={{
                  __html: String(messageDetail.text).replace(/\r?\n/g, '<br />')
                }}
              />
            ) : null}
          </>
        )}
      </div>
    </RightModalLayout>
  );
};

export default MessageDetailSidebar;
